import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { lessonStatusMeta } from '../utils/lessonStatus';

const { FiLayers } = FiIcons;

function CurriculumAssignments({ curriculum = [], child, onUpdateLesson }) {
  const readOnly = typeof onUpdateLesson !== 'function';
  const childName = child?.name || 'your child';

  const toggleAssignment = (lesson) => {
    if (readOnly) return;
    onUpdateLesson(lesson.id, {
      assigned: !lesson.assigned
    });
  };

  return (
    <section className="curriculum-card">
      <div className="section-heading">
        <div>
          <h2>Curriculum</h2>
          <p>
            {readOnly
              ? `Lessons on ${childName}’s tutor path.`
              : `Control which lessons are assigned to ${childName}’s tutor path.`}
          </p>
        </div>
        <span className="week-label">
          <SafeIcon icon={FiLayers} />
          {(curriculum || []).length} subjects
        </span>
      </div>

      {(curriculum || []).length === 0 ? (
        <div className="empty-state">
          <p>No curriculum assigned yet</p>
          <small>
            Lessons will appear here once they are assigned to {childName}.
          </small>
        </div>
      ) : (
        <div className="curriculum-groups">
          {curriculum.map((group) => (
            <div className="curriculum-group" key={group.subject}>
              <div className="subject-group-heading">
                <span className={`subject-dot ${group.subject.toLowerCase()}`} />
                <h3>{group.subject}</h3>
              </div>

              <div className="assignment-list">
                {(group.lessons || []).map((lesson) => {
                  const meta = lessonStatusMeta[lesson.status] || lessonStatusMeta.locked;

                  return (
                    <div className="assignment-row" key={lesson.id}>
                      <div className="assignment-info">
                        <span className="lesson-order">Lesson {lesson.order}</span>
                        <strong>{lesson.title}</strong>
                        <small>{lesson.description}</small>
                      </div>

                      <span className={`lesson-status-pill ${meta.className}`}>
                        <SafeIcon icon={meta.icon} />
                        {meta.label}
                      </span>

                      <label className={`assign-toggle${readOnly ? ' is-readonly' : ''}`}>
                        <input
                          checked={Boolean(lesson.assigned)}
                          disabled={readOnly}
                          onChange={() => toggleAssignment(lesson)}
                          type="checkbox"
                        />
                        <span className="toggle-track">
                          <span className="toggle-thumb" />
                        </span>
                        <span className="toggle-label">
                          {lesson.assigned ? 'Assigned' : 'Not assigned'}
                        </span>
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default CurriculumAssignments;
